import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './FutureEnhancements.css';

const sectionVariants = {
  hidden: { opacity: 0, y: 80, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      when: 'beforeChildren',
      staggerChildren: 0.08,
    },
  },
};

const childVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] } },
};

const FutureEnhancements = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' });
  return (
    <motion.section
      className="future-enhancements-section"
      ref={ref}
      variants={sectionVariants}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
    >
      <div className="future-enhancements-container">
        <motion.div className="future-enhancements-left" variants={childVariants}>
          <h2>Future Enhancements</h2>
          <p>
            We're constantly improving Genix AI. Here's a sneak peek at the powerful features we're building to
            make your healthcare experience even smarter and more personalized.
          </p>
          <a href="#" className="learn-more-button">
            Learn More <span className="arrow">↗</span>
          </a>
        </motion.div>
        <motion.div className="future-enhancements-right" variants={childVariants}>
          <motion.div className="feature-card-grid" variants={childVariants}>
            <motion.div className="feature-card" variants={childVariants}>
              <img src="/images/voiceCommand.png" alt="Voice Training" className="feature-icon" />
              <div className="feature-content-text">
                <h3>Voice Training</h3>
                <p>Customize response tones and assistant voice personalities.</p>
              </div>
            </motion.div>
            <motion.div className="feature-card" variants={childVariants}>
              <img src="/images/zoom.png" alt="Sentiment Detection" className="feature-icon" />
              <div className="feature-content-text">
                <h3>Sentiment Detection</h3>
                <p>Identify patient stress or discomfort in voice tone</p>
              </div>
            </motion.div>
            <motion.div className="feature-card" variants={childVariants}>
              <img src="/images/SmartPromptng.png" alt="Smart Prompting" className="feature-icon" />
              <div className="feature-content-text">
                <h3>Smart Prompting</h3>
                <p>Suggest follow-up questions or diagnosis hints in real time.</p>
              </div>
            </motion.div>
            <motion.div className="feature-card" variants={childVariants}>
              <img src="/images/Data-analytics.png" alt="Analytics Dashboard" className="feature-icon" />
              <div className="feature-content-text">
                <h3>Analytics Dashboard</h3>
                <p>Track clinician efficiency, language gaps, and note quality.</p>
              </div>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default FutureEnhancements; 